<template>
  <base-material-card :icon="resource.icon" :title="title">
    <va-list cursor-pagination>
      <va-data-table :fields="fields">
        <template #[`field.id`]="{ value }">
          <span class="monospaced-text">{{ value }}</span>
        </template>
        <template #[`field.lastUpdatedAt`]="{ value }">
          {{ new Date(value).toLocaleDateString('en-CA') }}
        </template>
      </va-data-table>
      <template #actions>
        <import-button color="success" text />
      </template>
    </va-list>
  </base-material-card>
</template>

<script>
import ImportButton from '@/components/buttons/ImportButton.vue';

export default {
  components: { ImportButton },
  props: {
    title: {
      type: String,
      default: '',
    },
    resource: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      fields: [{ source: 'id', link: 'show' }, { source: 'name' }, { source: 'lastUpdatedAt' }],
    };
  },
};
</script>
